import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ObjectManagement } from '../../models/object-management';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface PaymentDialogData {
  title: string;
  description?: string;
  inputValue: string;
  objectData?: ObjectManagement;
}

@Component({
  selector: 'app-payment-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './payment-dialog.component.html',
  styleUrl: './payment-dialog.component.scss'
})
export class PaymentDialogComponent {
 public readonly data: PaymentDialogData;

  constructor(
    /* Диалог – Desktop */
    @Optional()
    private dialogRef: MatDialogRef<PaymentDialogComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    dialogData: PaymentDialogData | null,

    /* Bottom-sheet – Mobile */
    @Optional()
    private sheetRef: MatBottomSheetRef<PaymentDialogComponent>,
    @Optional()
    @Inject(MAT_BOTTOM_SHEET_DATA)
    sheetData: PaymentDialogData | null
  ) {
    this.data = dialogData ?? sheetData!;
  }

  close(): void {
    this.dialogRef?.close();
    this.sheetRef?.dismiss();
  }

  apply(): void {
    const amount = Number(this.data.inputValue) * 100;
    this.dialogRef?.close(amount);
    this.sheetRef?.dismiss(amount);
  }
}
